export default __webpack_public_path__ + "static/media/hht1_ep15_timeline_q02_b.1df4b716.png";